import { useRoomSettings } from '@common/features/roomSettings';
import { useModuleStatuses } from '@features/properties';
import { ComponentProps, FC } from 'react';
import { MultiRoomSearch } from 'shared-types';
import GuestPickerComponent from '../../../../components/GuestPicker';
import { ClassFiltersColumn } from '../Filters.styles';

export type GuestsPickerProps = {
  showGuestsPicker?: boolean;
  onGuestCountChange: (guest: 'adults' | 'children', count: number, roomNumber?: number) => void;
  onRoomCountChange: (roomNumber?: number) => void;
  numberOfAdults: number;
  numberOfChildren: number;
  isSingle?: boolean;
  childAgesProps?: ComponentProps<typeof GuestPickerComponent>['childAgesProps'];
  onCloseGuestPicker?: ComponentProps<typeof GuestPickerComponent>['onClose'];
  toggleEditGuestDetails?: (isEditing: boolean) => void;
  editingGuestDetails?: boolean;
  rooms?: MultiRoomSearch;
};

export const GuestsPicker: FC<GuestsPickerProps> = ({
  showGuestsPicker = false,
  onGuestCountChange,
  numberOfAdults,
  numberOfChildren,
  isSingle = false,
  childAgesProps,
  onCloseGuestPicker,
  toggleEditGuestDetails,
  editingGuestDetails,
  rooms,
  onRoomCountChange,
}) => {
  const {
    statuses: { isRoomsEnabled },
  } = useModuleStatuses();

  const { data: roomSettings } = useRoomSettings(isRoomsEnabled);

  return showGuestsPicker ? (
    <ClassFiltersColumn>
      <GuestPickerComponent
        isSingle={isSingle || !!roomSettings?.data.adultOnlyBookings}
        numberOfAdults={numberOfAdults}
        numberOfChildren={numberOfChildren}
        onGuestCountChange={onGuestCountChange}
        childAgesProps={childAgesProps}
        onClose={onCloseGuestPicker}
        toggleEditGuestDetails={toggleEditGuestDetails}
        editingGuestDetails={editingGuestDetails}
        isMultiRoomsEnabled={roomSettings?.data.multiRoomSearchEnabled || false}
        rooms={rooms}
        onRoomCountChange={onRoomCountChange}
      />
    </ClassFiltersColumn>
  ) : null;
};
